import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';
import * as Sentry from "@sentry/react";
import Layout from './Layout';
import Screening from './pages/screening/Screening';
import ObgynPage from './pages/obgyn/ObgynPage';
import PromoPage from './pages/promo/PromoPage';
import './index.scss';
import NotFound from './pages/404/404';
import NonClinic from './pages/non-clinic/NonClinic';
import './i18n'

// sentry initialization
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE) || 0.2,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: JSON.parse(process.env.REACT_APP_SENTRY_TRACE_PROPAGATION_TARGETS || '["https://forms.hellolunajoy.com"]'),
  environment: process.env.REACT_APP_ENV || "development",
  enabled: process.env.REACT_APP_SENTRY_ENABLED === 'true',
});

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<Layout />}>
      <Route path='' element={<NonClinic slug={'phq9-gad7'} />} />
      <Route path='screening/'>
        <Route path='phq9-gad7' element={<NonClinic slug={'phq9-gad7'} />} />
        <Route path='phq2-gad2' element={<NonClinic slug={'phq2-gad2'} />} />
        <Route path='obgyn' element={<NonClinic slug={'obgyn'} />} />
        <Route path=':slug' element={<Screening />} />
        <Route path=':slug/:direct' element={<Screening />} />
      </Route>
      <Route path='ob-gyn/'  >
        <Route path=':slug' element={<ObgynPage />} />
      </Route>
      <Route path='ob-gyn/promo/' element={<PromoPage />} >
        <Route path=':slug' element={<PromoPage />} />
      </Route>
      <Route path='404/' element={<NotFound />} />
      <Route path='*'>
        <Route path=':path' element={<NonClinic />} />
      </Route>
    </Route>
  )
)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RecoilRoot>
    <RouterProvider router={router} />
  </RecoilRoot>
);

// If you want to start measuring performance in your app, pass a function
// added comment
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
